import React, { useState } from 'react';
import swal from 'sweetalert';
import Api from './Api';

const useDeleteData = (url) => {
    const HandleDelete = (e) => {
        swal({
            title: "Are you sure?",
            text: "Are you sure that you want to delete this record?",
            icon: "warning",
            dangerMode: false
        }).then(willDelete => {
            if (willDelete) {
                Api.delete(url + e)
                    .then(response => {
                        if (response.status == '200') {
                            swal("", "Deleted", "success");
                        } else {
                            swal("", response.statusText, "error");
                        }
                    })
                    .catch(err => {
                        swal("", "Failed", "error");
                    })
                    .then(function () {
                        // always executed
                    })
            }
        });

    }


    const HandleEditData = (data) => {
        Api.put(url + data.id, JSON.stringify(data)
        ).then(response => {

            if (response.status == '200') {
                swal("", "Edited", "success");
            } else {
                swal("", response.statusText, "error");
            }
        })
            .catch(err => {
                swal("", "Failed", "error");
            });
    }
    return { HandleDelete, HandleEditData }
}

export default useDeleteData;